module.exports = __webpack_public_path__ + "static/media/Project1.8f6db300.JPG";